import './App.css';
import { handleAnchorClick } from '../utils/smoothScroll';

function App() {
  return (
    <div className="App">
      <header className="App-nav">
        <span className="sitename">BD</span>
        <nav className="nav-links">
          <a href="#skills"        onClick={handleAnchorClick}>Skills</a>
          <a href="#projects"      onClick={handleAnchorClick}>Projects</a>
          <a href="#experience"    onClick={handleAnchorClick}>Experience</a>
          <a href="#education"     onClick={handleAnchorClick}>Education</a>
          <a href="#organizations" onClick={handleAnchorClick}>Organizations</a>
          <a href="#contact"       onClick={handleAnchorClick}>Contact</a>
        </nav>
      </header>
    </div>
  );
}
export default App;
